import { useUser } from '@auth0/nextjs-auth0/client';
import { lazy, Suspense, useCallback, useState } from 'react';

import ThemeToggleButton from '@/components/ThemeToggleButton';
import VerticalMenuIcon from '@/icons/verticalMenu';
import useHeaderState from '@/utils/hooks/useHeaderState';

const MenuDrawer = lazy(() => import('../../MenuDrawer'));

const ToggleButton = () => {
	const [visible, setVisible] = useState(false);
	// const { user } = useUser();
	const { isChecked } = useHeaderState();
	const showDrawer = useCallback(() => setVisible(true), []);
	const closeDrawer = useCallback(() => setVisible(false), []);

	return (
		<>
			{/* <div className="group relative top-2.5 z-50 ml-2 hidden py-5 pt-0 xl:block">
        <div className="icon-btn flex h-6 w-6 items-center justify-center outline-none">
          <VerticalMenuIcon
            className={`${visible && '!text-primary'} ${
              !isChecked
                ? 'text-header-gray group-hover:!text-primary dark:text-white'
                : 'text-header-gray group-hover:!text-primary dark:text-white'
            }`}
          />
        </div>
        <div
          className="absolute right-0 top-11 z-50 hidden flex-col space-y-4 rounded-lg bg-white p-4 shadow-lg 
          dark:bg-midnight group-hover:sm:flex">
          {user && (
            <>
              <UserProfileDisplay user={user} />
              <hr className="h-divider border-b-gray text-gray" />
            </>
          )}
          <div className="mb-2 flex items-center">
            {LINKS.HEADER.TOGGLE_MENU.map(({ displayName, link }) => (
              <CustomButtonLink
                key={displayName}
                href={link}
                useNextLink={false}
                target="_blank"
                className="h-auto p-0 font-normal capitalize text-header-gray hover:text-midnight hover:dark:text-white">
                {displayName}
              </CustomButtonLink>
            ))}
          </div>
          <div className="flex items-center justify-between space-x-4">
            <ThemeToggleButton />
            {user && (
              <CustomButtonLink
                useNextLink={false}
                href={PATHS.AUTH.LOGOUT}
                className="h-auto w-max bg-[linear-gradient(162deg,#DD1438_0%,#E42A6D_100%)] px-4 py-2 text-sm font-medium text-white 
                  dark:bg-[linear-gradient(162deg,#DD1438_0%,#5B01A2_100%)] dark:hover:bg-[linear-gradient(162deg,#DD1438_0%,#E42A6D_100%)]">
                Sign Out
              </CustomButtonLink>
            )}
          </div>
        </div>
      </div> */}

			<div className="flex-col rounded-3xl shadow-lg max-xl:hidden">
				{/* {user && (
          <>
            <UserProfileDisplay user={user} />
            <hr className="h-divider border-b-gray text-gray " />
          </>
        )} */}
				{/* <div className="mb-2 flex items-center">
          {LINKS.HEADER.TOGGLE_MENU.map(({ displayName, link }) => (
            <CustomButtonLink
              key={displayName}
              href={link}
              useNextLink={false}
              target="_blank"
              className="h-auto p-0 font-normal capitalize text-header-gray hover:text-midnight hover:dark:text-white">
              {displayName}
            </CustomButtonLink>
          ))}
        </div> */}
				<div className="flex items-center justify-between space-x-4 rounded-3xl">
					<ThemeToggleButton />
					{/* {user && (
            <CustomButtonLink
              useNextLink={false}
              href={PATHS.AUTH.LOGOUT}
              className="h-auto w-max bg-[linear-gradient(162deg,#DD1438_0%,#E42A6D_100%)] px-4 py-2 text-sm font-medium text-white 
                dark:bg-[linear-gradient(162deg,#DD1438_0%,#5B01A2_100%)] dark:hover:bg-[linear-gradient(162deg,#DD1438_0%,#E42A6D_100%)]">
              Sign Out
            </CustomButtonLink>
          )} */}
				</div>
			</div>
			<div className="block pl-0.5 xl:hidden">
				<button className="icon-btn flex h-6 w-6 items-center justify-end" aria-label="Menu" onClick={showDrawer}>
					<VerticalMenuIcon className={`${isChecked ? 'text-white' : 'text-primary'}`} />
				</button>
				{visible && (
					<Suspense>
						<MenuDrawer closeDrawer={closeDrawer} showLogin={false} user={{}} />
					</Suspense>
				)}
			</div>
		</>
	);
};

export default ToggleButton;
